import { useState } from 'react'
import { useGetMyInfosQuery } from '@/core/graphql/hooks'
import type { EthicsFormSubmission } from './types'

export function usePatientEthicsPage() {
  const [activeTab, setActiveTab] = useState(0)
  const { data, loading, error } = useGetMyInfosQuery()
  const myInfos = data?.myInfos

  const ethicsSubmissions = (myInfos?.formSubmissions || [])
    .filter((submission: EthicsFormSubmission) => submission.tags?.includes('ethics'))
    .sort((left: EthicsFormSubmission, right: EthicsFormSubmission) => new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime())

  return {
    activeTab,
    data,
    error,
    ethicsSubmissions,
    loading,
    myInfos,
    setActiveTab,
  }
}
